// ===================================================================
// KAIXO - Pestaña Alarmas
// ===================================================================
// Estado en tiempo real de las dependencias críticas + errores
// recientes capturados en memoria del proceso.
// ===================================================================

import React, { useEffect, useState, useCallback } from 'react';
import { adminAlarmsHealth, adminAlarmsErrors } from '../../../services/adminApi';
import './AdminAlarmsSection.css';

export default function AdminAlarmsSection() {
    const [health, setHealth] = useState(null);
    const [errors, setErrors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');

    const reload = useCallback(async () => {
        setLoading(true);
        setErr('');
        try {
            const [h, e] = await Promise.all([
                adminAlarmsHealth(),
                adminAlarmsErrors()
            ]);
            setHealth(h.data);
            setErrors(e.data?.errors || []);
        } catch (er) {
            setErr(er.response?.data?.error || er.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload();
        const t = setInterval(reload, 30 * 1000);  // refresca cada 30s
        return () => clearInterval(t);
    }, [reload]);

    return (
        <div className="aal-wrap">
            <div className="aal-head">
                <p className="aal-intro">
                    Health-check de las APIs externas. Refresco automático cada 30 segundos.
                </p>
                <button className="aal-refresh" onClick={reload}>↻ Refrescar</button>
            </div>

            {loading && !health && <div className="ap-loading">Comprobando servicios…</div>}
            {err && <div className="ap-error">{err}</div>}

            {health && (
                <>
                    <div className="aal-summary">
                        <span className="aal-sum-ok">{health.summary.ok} OK</span>
                        <span className="aal-sum-fail">{health.summary.fail} fallos</span>
                        <span className="aal-sum-skip">{health.summary.skipped} sin configurar</span>
                        <span className="aal-checked-at">
                            Última comprobación: {new Date(health.checkedAt).toLocaleTimeString()}
                        </span>
                    </div>

                    <div className="aal-grid">
                        {health.checks.map(c => (
                            <div key={c.name}
                                 className={`aal-card ${
                                    !c.configured ? 'aal-card-skip'
                                    : c.ok ? 'aal-card-ok' : 'aal-card-fail'
                                }`}>
                                <div className="aal-card-head">
                                    <strong>{c.name}</strong>
                                    <span className="aal-status-dot" />
                                </div>
                                <div className="aal-card-body">
                                    {!c.configured && <span>No configurado</span>}
                                    {c.configured && c.ok && <span>OK · {c.latencyMs}ms</span>}
                                    {c.configured && !c.ok && (
                                        <span title={c.error}>
                                            FALLO · {c.error?.slice(0, 60)}
                                        </span>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}

            <div className="aal-errors-section">
                <h4>Últimos errores capturados</h4>
                {errors.length === 0 && (
                    <div className="aal-no-errors">No hay errores recientes registrados. ✓</div>
                )}
                {errors.map((e, i) => (
                    <div key={i} className="aal-error-item">
                        <div className="aal-error-time">{new Date(e.at).toLocaleString()}</div>
                        <div className="aal-error-msg">
                            {e.context && <span className="aal-error-ctx">[{e.context}]</span>} {e.message}
                        </div>
                        {e.stack && (
                            <details>
                                <summary>Stack</summary>
                                <pre>{e.stack}</pre>
                            </details>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}
